<template lang="pug">

  el-menu.menu(:default-active="activeIndex",
  mode="horizontal", theme="dark", class='alpha-nav'
  :router="true")
    //- i.iconfont.icon-backward(@click="goBack()" title="后退")
    //- i.iconfont.icon-reload(@click="doReload()" title="刷新")
    el-menu-item(index="/newDesktop" @click="handleMenuClick('/newDesktop')") 工作台
    el-menu-item(index="/clientManage" @click="handleMenuClick('/clientManage')") 客户管理
    el-menu-item(index="/RadishManage" @click="handleMenuClick('/RadishManage')") 候选人
    el-menu-item(index="/projects" @click="handleMenuClick('/projects')") 我的项目
    //- el-menu-item(index="/myrencai" @click="handleMenuClick('/myrencai')") 我的人才
    el-menu-item(index="/fav2" @click="handleMenuClick('/fav2')") 收藏夹
    el-menu-item(index="/radish2" @click="handleMenuClick('/radish2')") 人才快搜
    el-menu-item(index="/bulletins" @click="handleMenuClick('/bulletins')") 情报
    el-submenu(index="#bao")
      template(slot="title") 宝藏
      //- el-menu-item(index="templateuploadnew") 模板
      //- el-submenu(index="#tocustomer")
      //-   template(slot="title") To客户
      //-   el-menu-item(index="")
      //-     div(@click="showCompanyReport") 客户公司合作回顾
      //-   el-menu-item(index="/statistics") 人才流动统计
      el-menu-item(index="/cvinfoV2" @click="handleMenuClick('/cvinfoV2')") 推荐历史
      el-menu-item(index="/newTalentFlow" @click="handleMenuClick('/newTalentFlow')") 人才流动统计
      el-menu-item(index="/contactlists" @click="handleMenuClick('/contactlists')") 通讯录
      el-menu-item(index="/knowledgebase" @click="handleMenuClick('/knowledgebase')") 知识库
      el-menu-item(index="/catalogue/模板" @click="handleMenuClick('/catalogue/模板')") 模板
      el-menu-item(index="/catalogue/培训" @click="handleMenuClick('/catalogue/培训')") 培训
      el-menu-item(index="/NewCompanyList" @click="handleMenuClick('/NewCompanyList')") 公司库

      el-menu-item(index="#gongsijinzhanbaogao" @click="showCompanyReport") 客户公司合作回顾
      //- el-menu-item(index="/talentFlow" @click="handleMenuClick('/talentFlow')") 人才流动汇总
      el-menu-item(index="/statistics" @click="handleMenuClick('/statistics')") 人才流动统计(旧)
      //- el-menu-item(index="/cvinfo" @click="handleMenuClick('/cvinfo')") 推荐历史
      //- el-menu-item(index="/talentFlow" @click="handleMenuClick('/talentFlow')") 人才流动汇总
      //- el-submenu(index="#training")
        //- template(slot="title") 培训
        //- el-menu-item(index="/training") 培训内容
        //- el-menu-item(index="/training") 阿尔法学园【培训】
        //- el-menu-item(index="#c42" @click="open('http://tanlearning.com:3030/#/')") 小碳培训系统
        //- el-menu-item(index="/faq") FAQ

      el-menu-item(index="/listdocuments" @click="handleMenuClick('/listdocuments')") 资源库搜索中心
      el-menu-item(index="/forecast" @click="handleMenuClick('/forecast')") 预测血库
      el-menu-item(index="/LeaderFlow" @click="handleMenuClick('/LeaderFlow')") 高管流动

    //- el-menu-item(index="/companylist") 公司
    //- el-menu-item(index="/projs") 项目
    el-submenu(index="#analyse")
      template(slot="title") 统计
      el-menu-item(index="/kpi3" @click="handleMenuClick('/kpi3')") KPI统计
      el-menu-item(v-if="isNotMember" index="/teammanage" @click="handleMenuClick('/teammanage')") 团队管理
      el-menu-item(index="/tag-completion" @click="handleMenuClick('/tag-completion')") 标签完成度
      el-menu-item(index="/salarystatistics" @click="handleMenuClick('/salarystatistics')") 薪酬
      el-menu-item(v-if="isAccountant" index="/SimpleFinance" @click="handleMenuClick('/SimpleFinance')") 财务报表
      el-menu-item(v-if="isEngineer" index="/finance" @click="handleMenuClick('/finance')") 旧财务报表

      el-menu-item(index="/points" @click="handleMenuClick('/points')") 体系化积分
      el-menu-item(index="/allcontactlist" @click="handleMenuClick('/allcontactlist')") list总表
    el-submenu(index="#admin")
      template(slot="title") 管理
      el-submenu(v-if="isNotMember" index="#setting")
        template(slot="title") 系统设置
        el-menu-item(index="/categories" @click="handleMenuClick('/categories')") 职能模块
        el-menu-item(index="/industries" @click="handleMenuClick('/industries')") 行业
        el-menu-item(v-if="isAdmin" index="/kpi-goal-set" @click="handleMenuClick('/kpi-goal-set')") KPI目标设置
      el-submenu(v-if="isAdmin" index="#user")
        template(slot="title") 用户管理
        el-menu-item(index="/users" @click="handleMenuClick('/users')") 用户
        el-menu-item(index="/permissions" @click="handleMenuClick('/permissions')") 权限
        el-menu-item(index="/kpisetting" @click="handleMenuClick('/kpisetting')") 业绩
        el-menu-item(index="/user-bulletin-permissions" @click="handleMenuClick('/user-bulletin-permissions')") 情报权限
        el-menu-item(index="/training-edit" @click="handleMenuClick('/training-edit')") 培训内容编辑
        el-menu-item(index="/kpisnew" @click="handleMenuClick('/kpisnew')") 周KPI
        //- el-menu-item(index="/group-management") 组织管理
        //- el-menu-item(index="/groups") 用户组
      el-submenu(index="#tong")
        template(slot="title") 统计分析
        el-menu-item(index="/fileupload" @click="handleMenuClick('/fileupload')") 文件上传统计
        el-menu-item(index="/beMonitor" @click="handleMenuClick('/beMonitor')") 网站后端性能分析
        el-menu-item(index="/radish-dup" @click="handleMenuClick('/radish-dup')") 重复数据
        el-menu-item(index="/tmp-radish" @click="handleMenuClick('/tmp-radish')") 缓存数据
        el-menu-item(index="/cvEval" @click="handleMenuClick('/cvEval')") 简历打分
        el-menu-item(index="/checkRecommend" v-if="isAdmin" @click="handleMenuClick('/checkRecommend')") 推荐报告匹配
      el-submenu(index="#othersetting")
        template(slot="title") 其他
        el-menu-item(index="/wechatfiles" @click="handleMenuClick('/wechatfiles')") 微信和邮箱文件
        el-menu-item(v-if="isAdmin || role" index="/workbench" @click="handleMenuClick('/workbench')") 行政工作台
        //- el-menu-item(v-if="isAdmin || role" index="/workbench2" @click="handleMenuClick('/workbench2')") 行政工作台2
        el-menu-item(index="/bindmanager" @click="handleMenuClick('/bindmanager')") 基金经理绑定
        el-menu-item(v-if="isAdmin" index="/sysnotify" @click="handleMenuClick('/sysnotify')") 系统公告
        el-menu-item(v-if="isAdmin" index="/school" @click="handleMenuClick('/school')") 学校排名
      el-menu-item(v-if="isBulletinAdmin" index="/starofweek" @click="handleMenuClick('/starofweek')") 本周公告
      el-menu-item(v-if="couldLoginUserSystem" @click="toUserSystem") 用户系统

      //- el-menu-item(index="#")
      //-   a(href="#/bugs" target="_blank" style="color:#909399") bug列表
      el-menu-item(index="/WeekListTogle" @click="handleMenuClick('/WeekListTogle')") 本周榜单
      el-menu-item(v-if="isAdmin" index="/PeixunAdmin") 培训课程配置
      el-menu-item(v-if="isAdmin" index="/PeixunStudents") 培训学员管理
      el-menu-item(index="/PeixunCeping") 能力雷达
      el-menu-item(v-if="isAdmin || hasOutsideExpert" index="/dizhu") 外部专家管理
      el-menu-item(v-if="isAdmin || couldCheckReview" index="/Summary") 顾问Review
      el-menu-item(v-if="isAdmin" index="userMedal") 用户勋章
      el-menu-item(index="/review") 新版review
      el-menu-item(index="/ProjectFollowV2Member" @click="handleMenuClick('/ProjectFollowV2Member')") 任务管理-成员
      el-menu-item(index="/ProjectFollowV2" @click="handleMenuClick('/ProjectFollowV2')") 任务管理-团队长

    //- el-menu-item(index="/catalogue/系统使用教学" @click="handleMenuClick('/catalogue/系统使用教学')") 系统使用教学

    el-submenu(index="#usersetting")
      template(slot="title")
          span(v-if="consultHelper" style="background-color: red;color: white;font-size: 24px;font-weight: bold") 提供者: {{consultHelper}}
          span(v-if="!consultHelper") {{username}}
      el-menu-item(index="#kpi3" @click="go('/kpi3')") KPI
      el-menu-item(index="#user-detail" @click="go('/user-detail')") 个人中心
      el-menu-item(v-if="isAdmin || role" index="/consult-helper" @click="go('/consult-helper')") 设置提供人
      //- el-menu-item(index="#offertable" @click="handleMenuClick('/offerTable')") 发票
      el-menu-item(index="#offertable" @click="handleMenuClick('/SimpleUserFinance')") 发票
      el-menu-item(index="#version")
        el-tooltip(:content="version" placement="left")
          div 系统版本
      el-menu-item(index="#logout" @click="logout") 退出
    div(class="handler")
      div(@click="toggleChuangguan" :style="{backgroundImage:'url('+require('../../assets/images/book.png')+')',width: '30px', height: '30px', 'background-size': 'cover', 'margin-right': '8px','background-color': '#fff',cursor:'pointer'}")
      a(class="notifier_toggle_btn" @click="notifierToggle")
        el-badge(class="mr20" :value="msgCount" :hidden="!msgCount" :max="99")
          i(class="el-icon-message pointer" style="font-size: 28px")
      div(@click="toggleZnAlpha" title="智能小阿" :style="{backgroundImage:`url('https://alphahr.oss-cn-beijing.aliyuncs.com/documents/upload/cute.gif')`,width: '60px', height: '45px', 'background-size': 'cover', 'margin-right': '8px','background-color': '#fff',cursor:'pointer'}")
      el-dropdown(trigger="click")
        el-button(type="primary" size='small' icon="el-icon-plus" dark style="font-size: 14px") 新增/上传
        el-dropdown-menu(slot="dropdown")
          el-dropdown-item
            div(@click='addRadish') 新增人选
          //- el-dropdown-item(v-if="isTechnician")
          //-   div(@click='addProject') 旧新增项目
          el-dropdown-item
            div(@click="newTestAddCompany") 新增公司
          //- el-dropdown-item(v-if="isTechnician")
          //-   div(@click='toAddProject') 测试新增项目
          el-dropdown-item
            div(@click='createProject20') 新增项目
          //- el-dropdown-item
          //-   div(@click='testAddProject') 新增项目
          el-dropdown-item
            div(@click='uploadList') 通讯录上传
          el-dropdown-item
            div(@click='importSl') 导入SL
          el-dropdown-item
            div(@click='importCv') 导入CV
          el-dropdown-item
            div(@click="uploadFile") 文件上传
          el-dropdown-item
            div(v-if="isAdmin || role" @click='addCompanyTest') 新增公司（数据专用）
          el-dropdown-item(v-if="isAdmin")
            div(@click='uploadWande') 万德数据上传
      UploadDialog(ref="upload" type="附件" :on-success="afterUpload" :limit="1")
      UploadDialog(ref="wande" type="wande" title="上传万德数据" :on-success="afterUploadWande" :limit="1")
      LinkFile(:visible.sync="linkFileVisible" :linkTarget="linkFile")
      UploadListDialog(ref="UploadListDialog")
</template>

<script>
import LinkFile from '../../project/src/dialog/LinkFileV3.vue'
import UploadListDialog from '../../file/src/components/UploadListDialog'

const zxcvbn = require('zxcvbn')

const IndexLabelMap = {
  '/newDesktop': '工作台',
  '/radish2': '人才',
  '/NewCompanyList': '公司',
  '/projects': '项目',
  '/bulletins': '情报',
  '/talentFlow': '人才流动汇总',
  '/statistics': '人才流动统计',
  '/cvinfo': '推荐历史',
  '/contactlists': '通讯录',
  '/knowledgebase': '知识库',
  '/catalogue/模板': '模板',
  '/catalogue/培训': '培训',
  '/catalogue/系统使用教学': '系统使用教学',
  '/listdocuments': '资源库搜索中心',
  '/kpi2': 'KPI统计',
  '/teammanage': '团队管理',
  '/tag-completion': '标签完成度',
  '/salarystatistics': '薪酬',
  '/finance': '财务报表',
  '/offerTable': 'offer统计',
  '/points': '体系化积分',
  '/allcontactlist': 'list总表',
  '/categories': '职能模块',
  '/industries': '行业',
  '/kpi-goal-set': 'KPI目标设置',
  '/users': '用户',
  '/permissions': '权限',
  '/kpisetting': '业绩',
  '/user-bulletin-permissions': '情报权限',
  '/training-edit': '培训内容编辑',
  '/kpisnew': '周KPI',
  '/fileupload': '文件上传统计',
  '/beMonitor': '网站后端性能分析',
  '/radish-dup': '重复数据',
  '/tmp-radish': '缓存数据',
  '/cvEval': '简历打分',
  '/checkRecommend': '推荐报告匹配',
  '/wechatfiles': '微信和邮箱文件',
  '/workbench': '行政工作台',
  '/bindmanager': '基金经理绑定',
  '/sysnotify': '系统公告',
  '/school': '学校排名',
  '/starofweek': '本周公告',
}

export default {
  components: { LinkFile, UploadListDialog },
  props: { msgCount: { type: Number, default: undefined } },
  data() {
    return {
      activeIndex: '/',
      old_password: '',
      new_password: '',
      strength: '',
      version: __VERSION__,
      linkFileVisible: false,
      linkFile: {},
      isBulletinAdmin: false,
    }
  },
  computed: {
    isAdmin() {
      return app.user.角色 && app.user.角色.includes('管理员')
    },
    isTechnician() {
      return app.user.组别 && app.user.组别.includes && app.user.组别.includes('技术部')
    },
    couldLoginUserSystem() {
      try {
        const roles = (Array.isArray(app.user.角色) ? app.user.角色 : [app.user.角色]).filter(v => v)
        const couldLoginRoles = ['管理员', '行政']
        let flag = false
        roles.forEach(v => {
          if (couldLoginRoles.includes(v)) flag = true
        })

        return flag || app.user.用户系统 === '有'
      } catch (e) {
        console.log(e)
        return false
      }
    },
    isNotMember() {
      return app.user.角色 && !app.user.角色.includes('普通用户')
    },
    hasOutsideExpert() {
      return app.user.外部专家管理
    },
    couldCheckReview() {
      return app.user.review查看
    },
    username() {
      let ref
      return (ref = app.user) != null ? ref['姓名'] : void 0
    },
    consultHelper() {
      return (app.user && app.user.提供者) || ''
    },
    account() {
      return app.user.account
    },
    role() {
      return (app.user.角色 && app.user.角色.includes('行政')) || app.user['微信数据'] || app.user.行政工作台 === '有'
    },
    isEngineer() {
      return (Array.isArray(app.user.组织类型) && app.user.组织类型.includes('技术团队'))
    },
    isAccountant() {
      const account = app.user.account
      if (['DanielWenbo'].includes(account)) {
        return false
      } else if (app.user['角色']) {
        return app.user.角色 && (app.user.角色.includes('管理员') || app.user.角色.includes('财务'))
      } else {
        return false
      }
    },
    isExpUser() {
      const expUsers = [
        'CathyJiang',
        'NateYu',
        'LanBin',
        'chenshen',
        'IrisWang',
        'MilosXie',
        'Lidia',
        'MiaZhang',
        'LixueYin',
        'KrystalDing',
        'frank',
      ]
      return expUsers.includes(app.user.account)
    },
  },
  watch: {
    $route() {
      let ai
      ai = location.href.replace(/^.*?#\//, '').replace(/\/.*$/, '')
      ai = `/${ai}`
      return (this.activeIndex = ai)
    },
    new_password() {
      return this.showStrength()
    },
  },
  mounted() {
    this.getBulletinAdmin()
  },
  methods: {
    toJiaoxue() {
      this.go('/catalogue/系统使用教学')
      this.handleMenuClick('/catalogue/系统使用教学')
    },
    newTestAddCompany() {
      window.open(`${window.origin}/#/NewAddCompany`, '_blank')
    },
    toUserSystem() {
      window.open('https://user.alphaconsulting.top/#/', '_blank')
    },
    async testAddProject() {
      await app.service('project').saveRecords({ type: '新增项目', path: '新增项目', page: '导航栏' })
      this.zIndex = app.root.dragindex++
      window.open(`${window.origin}/#/createProject`, '_blank')
      // this.$router.push('/createProject')
    },
    toAddProject() {
      app.root.$refs.NewAddProject.open()
      // window.open(`${window.origin}/#/testAddProject`)
    },
    createProject20() {
      window.open(`${window.origin}/#/createProject20`, '_blank')
    },
    addProjectTest() {
      app.root.$refs.AddProject.open()
    },
    async getBulletinAdmin() {
      const res = await app.service('company').getBulletinAdmin()
      if (res.status === 'success') {
        const admins = res.data.map(val => val.account)
        this.isBulletinAdmin = admins.includes(app.user.account)
      }
    },
    open(url) {
      return window.open(url)
    },
    go(url) {
      return router.push(url)
    },
    logout() {
      return app.logout().then(() => location.reload())
    },
    showStrength() {
      let zx
      zx = zxcvbn(this.new_password)
      if (zx.score < 3) {
        this.strength = '弱'
        return
      }
      if (zx.score === 3) {
        this.strength = '中'
        return
      }
      if (zx.score > 3) {
        return (this.strength = '强')
      }
    },
    changePassword() {
      app.root.$refs.resetPass.dialogVisible = true
      app.root.$refs.resetPass.showClose = true
    },
    goBack() {
      return window.history.back()
    },
    doReload() {
      return window.location.reload()
    },
    addProject() {
      app.root.$refs.addProjectFull.open()
    },
    async addRadish() {
      this.collapseOther()
      await app.service('project').saveRecords({ type: '新增人选', path: '新增人选', page: '导航栏' })
      this.zIndex = app.root.dragindex++
      app.root.$refs.radishAdd.open()
    },
    async importCv() {
      this.collapseOther()
      await app.service('project').saveRecords({ type: '导入CV', path: '导入CV', page: '导航栏' })
      app.root.$refs.radishCvUpload.open()
    },
    async importSl() {
      this.collapseOther()
      await app.service('project').saveRecords({ type: '导入SL', path: '导入SL', page: '导航栏' })
      app.root.$refs.radishExcelUpload.open()
    },
    async addCompanyTest() {
      await app.service('project').saveRecords({ type: '新增公司', path: '新增公司', page: '导航栏' })
      app.root.$refs.createCompany.open()
    },
    collapseOther() {
      app.root.$refs.radishDetailTab.collapse()
      app.root.onPush()
    },
    // async uploadList() {
    //   await app.service('project').saveRecords({ type: '通讯录上传', path: '通讯录上传', page: '导航栏' })
    //   this.zIndex = app.root.dragindex++
    //   app.root.upload('list')
    // },
    async uploadFile() {
      await app.service('project').saveRecords({ type: '文件上传', path: '文件上传', page: '导航栏' })
      this.$refs.upload && this.$refs.upload.visible(true)
    },
    uploadWande() {
      this.$refs.wande && this.$refs.wande.visible(true)
    },
    notifierToggle() {
      app.root.$refs.NotifyList.toggle()
    },
    afterUpload(response, file, fileList) {
      this.linkFile = (response && response[0]) || {}
      this.$confirm(`“${this.linkFile.originalname}”上传成功, 是否需要将其挂载成附件?`, '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      })
        .then(() => {
          this.$refs.upload.visible(false)
          this.linkFileVisible = true
        })
        .catch(() => {})
    },
    async afterUploadWande(response, file, fileList) {
      if (response && response[0]) {
        const doc = response[0]
        const res = await app.service('radish').saveWande({ doc })
        if (res.status === 'success') {
          this.$message('数据上传完毕，正在后台解析，稍后会通过系统消息通知解析结果')
          this.$refs.wande.clean()
          this.$refs.wande.visible()
        } else {
          this.$message.error(res.msg)
          this.$refs.wande.clean()
        }
      } else {
        this.$message.error('上传失败')
        this.$refs.wande.clean()
      }
    },
    async showCompanyReport() {
      await app.service('project').saveRecords({ type: '客户公司合作回顾', path: '点击菜单栏', page: '导航栏' })
      app.root.$refs.CompanyReportDialog.show()
    },
    async handleMenuClick(index) {
      const label = IndexLabelMap[index]
      if (label) {
        await app.service('project').saveRecords({ type: label, path: '点击菜单栏', page: '导航栏' })
      }
      this.activeIndex = index
      this.$router.push(index)
    },
    async uploadList() {
      await app.service('project').saveRecords({ type: '通讯录上传', path: '通讯录上传', page: '导航栏' })
      this.$refs.UploadListDialog.visible()
    },
    toggleZnAlpha() {
      app.root.$refs.ZnAlpha.toggle()
    },
    toggleChuangguan() {
      app.root.$refs.Chuangguan.toggle()
    },
  },
}
</script>
<style>
@media screen and (max-width: 1460px) {
  .alpha-nav .el-submenu__title,
  .alpha-nav .el-menu-item {
    padding: 0 10px;
  }
}
</style>
<style scoped>
.handler {
  position: absolute;
  top: 0;
  right: 140px;
  height: 100%;

  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;

  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.handler::before {
  content: '';
  display: block;
  position: absolute;
  left: -30px;
  top: 12px;
  width: 2px;
  height: 60%;
  background-color: #d4d4d4;
}
</style>
